import React from 'react';
import { Header } from '../components/Header';
import { OfferHero } from '../components/OfferHero';
import { ProblemSolution } from '../components/ProblemSolution';
import { Modules } from '../components/Modules';
import { Benefits } from '../components/Benefits';
import { Trainers } from '../components/Trainers';
import { ForWhom } from '../components/ForWhom';
import { Pricing } from '../components/Pricing';
import { OfferTestimonials } from '../components/OfferTestimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { SectionDivider } from '../components/ui';
import { CTAProvider } from '../components/CTAContext';
const navLinks = [{
  label: 'Module',
  target: 'module'
}, {
  label: 'Beneficii',
  target: 'beneficii'
}, {
  label: 'Despre noi',
  target: 'despre'
}, {
  label: 'Înscriere',
  target: 'pricing'
}, {
  label: 'Întrebări',
  target: 'faq'
}];
export const OfferPage = () => {
  return <CTAProvider config={{
    mode: 'whatsapp',
    label: 'Contactează-mă pe WhatsApp'
  }} data-id="element-515">
      <div className="min-h-screen bg-navy text-textLight font-sans selection:bg-gold/30 selection:text-white" data-id="element-516">
        <Header links={navLinks} enrollTarget="pricing" data-id="element-517" />
        <OfferHero data-id="element-518" />
        <SectionDivider data-id="element-519" />
        <ProblemSolution data-id="element-520" />
        <SectionDivider data-id="element-521" />
        <Modules data-id="element-522" />
        <SectionDivider data-id="element-523" />
        <Benefits data-id="element-524" />
        <SectionDivider data-id="element-525" />
        <Trainers data-id="element-526" />
        <SectionDivider data-id="element-527" />
        <ForWhom data-id="element-528" />
        <SectionDivider data-id="element-529" />
        <Pricing data-id="element-530" />
        <OfferTestimonials data-id="element-531" />
        <SectionDivider data-id="element-532" />
        <FAQ data-id="element-533" />
        <Footer data-id="element-534" />
      </div>
    </CTAProvider>;
};